import React from "react";
import { connect } from "react-redux";
import Modal from "Utils/Modal";
import ScrollArea from "Utils/react-scrollbar";
import { closeExportSuccessModal } from "Actions/ProgressBarActions";

class ExportSuccessModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      response: {},
      fileUrl: null
    };
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }

  // Imperative API kept for existing per-component ref usages.
  open(response, fileUrl) {
    this.setState({
      response: response,
      open: true,
      fileUrl: fileUrl
    });
  }

  close() {
    const { closeExportSuccessModal } = this.props;
    this.setState({
      open: false,
      response: {},
      fileUrl: null
    });
    // If rendered as the global instance, also clear Redux state.
    if (closeExportSuccessModal) {
      closeExportSuccessModal();
    }
  }

  render() {
    // When used as the global instance (mounted in TopHeader), read from Redux.
    // When used as a per-component instance via ref, read from local state.
    const {
      exportSuccessOpen,
      exportSuccessResponse,
      exportSuccessFileUrl,
    } = this.props;

    const isGlobal = exportSuccessOpen !== undefined;

    const open     = isGlobal ? exportSuccessOpen          : this.state.open;
    const response = isGlobal ? (exportSuccessResponse || {}) : this.state.response;
    const fileUrl  = isGlobal ? exportSuccessFileUrl        : this.state.fileUrl;

    let actions = [
      <a className="btn full" onClick={this.close}>
        OK
      </a>
    ];

    let title = "Something went wrong";

    if (!response.errors || response.errors.length === 0) {
      if (fileUrl) {
        actions = [
          <a
            id="download_export_file"
            className="btn full"
            target="_blank"
            rel="noopener noreferrer"
            href={fileUrl}
            download
          >
            Download Export File
          </a>
        ];
      }
      title = "Export completed!";
    }

    return (
      <Modal
        open={open}
        toggle={this.close}
        title={title}
        actions={actions}
      >
        <p>{response.message}</p>
        {response.errors && response.errors.length > 0 && (
          <div>
            <h3>{typeof response.errors !== 'string' && response.errors.length} Errors:</h3>
            <ScrollArea speed={0.8} horizontal={false}>
              {typeof response.errors !== 'string' ? (
                <div>
                  {response.errors.map(err => {
                    const row = err[0];
                    const rowErrors = err[1];
                    return Object.keys(rowErrors).map(rowErrName => {
                      const rowErr = rowErrors[rowErrName];
                      return (
                        <div key={`${row}-${rowErrName}`}>
                          Row {row} - {rowErr}
                        </div>
                      );
                    });
                  })}
                </div>
              ) : (
                <div>{response.errors}</div>
              )}
            </ScrollArea>
          </div>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    exportSuccessOpen,
    exportSuccessResponse,
    exportSuccessFileUrl,
  } = state.progressBar;
  return {
    exportSuccessOpen,
    exportSuccessResponse,
    exportSuccessFileUrl,
  };
};

// Named export for the global instance (Redux-connected, used in TopHeader).
export const GlobalExportSuccessModal = connect(
  mapStateToProps,
  { closeExportSuccessModal }
)(ExportSuccessModal);

// Default export keeps the unconnected class so existing ref-based usages
// throughout the codebase continue to work without any changes.
export default ExportSuccessModal;
